module.exports = __webpack_public_path__ + "84130d886972151bc3b658fd1bbb740b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/tea-pot-s.png
// module id = 2624
// module chunks = 0